if (!customElements.get('product-info')) {

const form = document.querySelector('form[id^="product-form-template"]');
  
        const updatePanneaux = (variantId) => {
          const hasKeyWithPanneauNumber = (metafields) => {
            const pattern = /^(?:panneau_|panel_)\d+$/;
            for (const key in metafields) {

              if (metafields.hasOwnProperty(key)) {

                const keys = Object.keys(metafields[key]);
                if (keys.some(k => pattern.test(k))) {

                  return true;
                }
              }
            }
            return false;
          };

            if(hasKeyWithPanneauNumber(window.variantMetafields)){
              const values = window.variantMetafields[variantId];

              let divs = [...document.querySelectorAll('div[id^="panneau "]')] || [...document.querySelectorAll('div[id^="panel "]')];

              const dessusDiv = document.querySelector('div[id^="dessus"]' || document.querySelector('div[id^="top"]'));
              if(dessusDiv){
                divs.push(dessusDiv)
              }
              const cotesDiv = document.querySelector('div[id^="cotes"]' || document.querySelector('div[id^="sides"]'));
              if(cotesDiv){
                divs.push(cotesDiv)
              }
              
              divs.forEach(div => {
                const key = div.id.replaceAll(" ", "_").toLowerCase();
                if (values[key] === true) {
                  
                  div.style.display = "block";
                  const radioButtons = div.querySelectorAll('input[type="radio"]');
                  const isChecked = Array.from(radioButtons).some(radio => radio.checked);
                  if(!isChecked){

                    radioButtons[0].click()
                  }
                } else {
                  div.style.display = "none";
                  const radioButtons = div.querySelectorAll('input[type="radio"]');
                  radioButtons.forEach(radio => {
                    radio.checked = false;
                  });
                  const spans = div.querySelectorAll('span');
                  if (spans.length > 0) {
                    spans[0].innerText = "None";
                  }
                  const panneauName = div.querySelector("fieldset legend").innerText
                  .split(":")[0]                
                  .toLowerCase()                 
                  .replace(/ /g, "_");  
                  let input = document.querySelector(`#${panneauName}`);
                  if(input) {
                    form.removeChild(input)
                  }
                }
              });
            }else{
              let divs = [...document.querySelectorAll('div[id^="panneau "]')] || [...document.querySelectorAll('div[id^="panel "]')];

              const dessusDiv = document.querySelector('div[id^="dessus"]' || document.querySelector('div[id^="top"]'));
              if(dessusDiv){
                divs.push(dessusDiv)
              }
              const cotesDiv = document.querySelector('div[id^="cotes"]' || document.querySelector('div[id^="sides"]'));
              if(cotesDiv){
                divs.push(cotesDiv)
              }

              divs.forEach(div => {
                const key = div.id.replaceAll(" ", "_").toLowerCase();

                  div.style.display = "block";
                  const radioButtons = div.querySelectorAll('input[type="radio"]');
                  const isChecked = Array.from(radioButtons).some(radio => radio.checked);
                  if(!isChecked){

                    radioButtons[0].click()
                  }
                });
            }
        };

        const checkSubmission = () => {
          const submissionMessage = document.getElementById('message-soumission');
          if(submissionMessage){

              const input = document.createElement('input');
              input.type = 'hidden';
              input.id = 'message-soumission';
              input.name = `properties[IMPORTANT]`;
              input.value = submissionMessage.innerText
              form.appendChild(input);
          }
        };

        const updateProportions = (variantId) => {

          const variant = currentProduct.variants.find(variant => variant.id === parseInt(variantId));
          const poidsEnGrammes = variant ? variant.weight : null;

          
          const values = window.variantMetafields[variantId];
          const largeurElement = document.getElementById('largeur');
          const profondeurElement = document.getElementById('profondeur');
          const hauteurElement = document.getElementById('hauteur');
          const poidsElement = document.getElementById('poids');

          if(values.largeur2){
            largeurElement.style.display = "inline"; 
            largeurElement.innerHTML = `<i class="fas fa-arrows-h"></i> ${values.largeur2.value}${values.max_largeur ? ` - ${values.max_largeur.value}` : ''}${checkUnit(values.largeur2.unit)}`;
          }else {
            largeurElement.style.display = "none"; 
          }
          
          if(values.longueur){
            profondeurElement.style.display = "inline"; 
            profondeurElement.innerHTML = `<i class="fas fa-expand-alt"></i> ${values.longueur.value}${checkUnit(values.longueur.unit)}`;
          }else {
            profondeurElement.style.display = "none"; 
          }
          
          if(values.hauteur2){
            hauteurElement.style.display = "inline"; 
            hauteurElement.innerHTML = `<i class="fas fa-arrows-v"></i> ${values.hauteur2.value}${values.max_hauteur ? ` - ${values.max_hauteur.value}` : ''}${checkUnit(values.hauteur2.unit)}`
          }else {
            hauteurElement.style.display = "none"; 
          }

          if(poidsEnGrammes) {
            const poidsEnLivres = poidsEnGrammes / 453.592
            poidsElement.style.display = "inline"; 
            poidsElement.innerHTML = `<i class="fas fa-weight-hanging"></i> ${parseInt(poidsEnLivres.toFixed(2))} lb`
          }else {
            poidsElement.style.display = "none"; 
          }
        };

        const checkUnit = (unit) => {
          switch (unit) {
        case "in":
          return '"'
          break;
        case "ft":
          return "'"
          break;
        default:
          return " " + unit
          break;
      }
        }

          const updateEtat = (variantId) => {
          
          const values = window.variantMetafields[variantId];
          const etatElement = document.getElementById('etat-produit');

          if(etatElement){
            if(values.etat){
              etatElement.style.display = "inline";
              const iElement = etatElement.innerHTML.split("</i>")
              etatElement.innerHTML = `${iElement[0]}</i>${values.etat}`;
            }else {
              etatElement.style.display = "none"; 
            }
          }
        };
          function handleQuickBuySubmit(event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            alert("This button is disabled and cannot be re-enabled manually.");
          }

        const updateTransportNonStandard = (variantId) => {
          
          const messageElement = document.getElementById('message-transport');
          const values = window.variantMetafields[variantId];
          
          if(values.transport_non_standard === true){
            
            messageElement.style.display = "block";
            
            const input = document.createElement('input');
            input.type = 'hidden';
            input.id = 'message-transport-cart';
            input.name = `properties[IMPORTANT]`;
            input.value = messageElement.innerText
            form.appendChild(input);

            const quickBuy = document.querySelector("shopify-accelerated-checkout");
            if(quickBuy) {
              quickBuy.addEventListener("click", handleQuickBuySubmit, true);
              quickBuy.addEventListener("mousedown", handleQuickBuySubmit, true);
              quickBuy.addEventListener("mouseup", handleQuickBuySubmit, true);
              quickBuy.addEventListener("touchstart", handleQuickBuySubmit, true);
              quickBuy.addEventListener("touchend", handleQuickBuySubmit, true);
              
              quickBuy.style.display = "none"
            }
            
          }else {
            messageElement.style.display = "none";
            const existingInput = document.getElementById('message-transport-cart');
              if (existingInput) {
                existingInput.remove();
              }
            const quickBuy = document.querySelector("shopify-accelerated-checkout");

            if(quickBuy) {
              quickBuy.removeEventListener("click", handleQuickBuySubmit, true);
              quickBuy.removeEventListener("mousedown", handleQuickBuySubmit, true);
              quickBuy.removeEventListener("mouseup", handleQuickBuySubmit, true);
              quickBuy.removeEventListener("touchstart", handleQuickBuySubmit, true);
              quickBuy.removeEventListener("touchend", handleQuickBuySubmit, true);
              
              quickBuy.style.display = "block"
          }
          }
        }

        const initDescription = () => {
          if(!currentProduct.metafields.custom.decription_complete_exists){
            const collapsibleElement = document.querySelector('[id*="collapsible_content"]');
            const descriptionHeaders = collapsibleElement.querySelectorAll('h3.accordion__title.inline-richtext.h4');
  
            descriptionHeaders.forEach(header => {
              if (header.textContent.trim() === 'Description') {
                const parentElement = header.closest('.accordion');
  
                parentElement.style.display = "none"
              }
            });
          }
        }

          const initDocuments = () => {
          if(!currentProduct.metafields.custom.pdf_documents_exists){
            const collapsibleElement = document.querySelector('[id*="collapsible_content"]');
            const documentsHeaders = collapsibleElement.querySelectorAll('h3.accordion__title.inline-richtext.h4');
  
            documentsHeaders.forEach(header => {
              if (header.textContent.trim() === 'Documents' || header.textContent.trim() === 'Docs') {
                const parentElement = header.closest('.accordion');
  
                parentElement.style.display = "none"
              }
            });
          }
        }

  const params = new URLSearchParams(window.location.search);
  if(params.get("variant") === null){
    const variantId = currentProduct.variants[0].id
    updatePanneaux(variantId);
    updateProportions(variantId);
    updateEtat(variantId);
    updateTransportNonStandard(variantId);
  } else {
  const variantId = params.get("variant")
  updatePanneaux(variantId);
  updateProportions(variantId);
  updateEtat(variantId);
  updateTransportNonStandard(variantId);
  }
  checkSubmission();
  initDescription();
  initDocuments();

  
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
          updatePanneaux(variant?.id)
          updateProportions(variant?.id)
          updateEtat(variant?.id)
          updateTransportNonStandard(variant?.id);
          

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
